import React, { useEffect } from "react";

// react-bootstrap components
import { Button, Navbar, Container } from "react-bootstrap";
import { apiService } from "../../service/ApiService";
import StoreSelect from "../DropDowns/StoreSelect";
import CreditsItem from "components/Custom/CreditsItem";
import LanguageSwitcher from "components/LanguageSwitcher/LanguageSwitcher";

function HipposAdminNavbar() {
  const [collapseOpen, setCollapseOpen] = React.useState(false);

  // Load the initial selected store from local storage on component mount
  useEffect(() => {
    // const storedStore = localStorage.getItem('selectedStore');
    // if (storedStore) {
    //     setSelectedStore(JSON.parse(storedStore));
    // }
  }, []);

  return (
    <>
      <Navbar expand="lg">
        <Container fluid>
          <div className="navbar-wrapper col-md-2 col-sm-2 col-xs-2 col-2">
            <div className="navbar-minimize">
              <Button
                className="btn-fill btn-round btn-icon d-none d-lg-block bg-dark border-dark"
                variant="dark"
                onClick={() => document.body.classList.toggle("sidebar-mini")}
              >
                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i className="fas fa-bars visible-on-sidebar-mini"></i>
              </Button>
              <Button
                className="btn-fill btn-round btn-icon d-block d-lg-none bg-dark border-dark"
                variant="dark"
                onClick={() => document.documentElement.classList.toggle("nav-open")}
              >
                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i className="fas fa-bars visible-on-sidebar-mini"></i>
              </Button>
            </div>
          </div>
          <div className="col-md-5 col-sm-10 col-10 d-flex align-items-center">
            <div className="flex-grow-1">
              <StoreSelect />
            </div>
            <div className="flex-shrink-0 ml-3">
              <LanguageSwitcher className="admin-language-dropdown" />
            </div>
          </div>
          {/* <button className="navbar-toggler navbar-toggler-right border-0" type="button" onClick={() => setCollapseOpen(!collapseOpen)}>
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
          </button> */}
          {/* <Navbar className="justify-content-end" in={collapseOpen}> */}
            {/* <Nav navbar className="col-md-1 col-sm-2">
              <Dropdown as={Nav.Item} className="float-right">
                <Dropdown.Toggle as={Nav.Link} id="dropdown-41471887333" variant="default">
                  <i className="nc-icon nc-bullet-list-67"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu alignRight aria-labelledby="navbarDropdownMenuLink">
                  <CreditsItem />
                  <Dropdown.Item href={`/admin/user/${apiService.getId()}`}>
                    <i className="nc-icon nc-circle-09"></i>
                    Προφίλ
                  </Dropdown.Item>
                  <div className="divider"></div>
                  <Dropdown.Item
                    className="text-danger"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      apiService.logout();
                    }}
                  >
                    <i className="nc-icon nc-button-power"></i>
                    Αποσύνδεση
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav> */}
          {/* </Navbar> */}
        </Container>
      </Navbar>
    </>
  );
}

export default HipposAdminNavbar;
